import { render, staticRenderFns } from "./CorporateTopProjects.vue?vue&type=template&id=3fdaa2cc&scoped=true&"
import script from "./CorporateTopProjects.vue?vue&type=script&lang=ts&"
export * from "./CorporateTopProjects.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateTopProjects.vue?vue&type=style&index=0&id=3fdaa2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaa2cc",
  null
  
)

export default component.exports